export default __webpack_public_path__ + "static/nowabasn-e9c1718d45a7b79c56e40c410af3e58a.png";